import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './homepageHeader.css';

const HomepageHeader = ({ items }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const scrollToNext = () => {
    const el = document.querySelector('.background-gray');
    const navbar = document.querySelector('.navbar-container');
    if (el) {
      const offset = el.getBoundingClientRect().top + window.scrollY - (navbar ? navbar.offsetHeight : 0);
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  };

  return (
    <div className={`hero-section ${isVisible ? 'hero-visible' : ''}`}>
      <div className="hero-inner">
        <p className="hero-eyebrow">{items.eyebrow}</p>
        <h1 className="hero-heading">{items.heading}</h1>
        <p className="hero-description">{items.description}</p>
        <div className="hero-buttons">
          <Link to="/services" className="hero-btn hero-btn--primary">
            {items.btnServices}
          </Link>
          <button className="hero-btn hero-btn--secondary" onClick={scrollToNext}>
            {items.btnLearn}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomepageHeader;
